import { render, staticRenderFns } from "./Notificator.vue?vue&type=template&id=374e965c&scoped=true&"
import script from "./Notificator.vue?vue&type=script&lang=js&"
export * from "./Notificator.vue?vue&type=script&lang=js&"
import style0 from "./Notificator.vue?vue&type=style&index=0&id=374e965c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e965c",
  null
  
)

export default component.exports